var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.331 16.8l-2.965 2.966A.8.8 0 014 19.2V6.4A2.4 2.4 0 016.4 4h11.2A2.4 2.4 0 0120 6.4v8a2.4 2.4 0 01-2.4 2.4H8.331zm-.897-1.366A.8.8 0 018 15.2h9.6a.8.8 0 00.8-.8v-8a.8.8 0 00-.8-.8H6.4a.8.8 0 00-.8.8v10.869l1.834-1.835zM12.152 9.6a.745.745 0 110 1.49.745.745 0 010-1.49zm-3.407 0a.745.745 0 110 1.49.745.745 0 010-1.49zm6.814 0a.745.745 0 110 1.49.745.745 0 010-1.49z"
  })));
};

export default SvgChat;